module.exports = __webpack_public_path__ + "static/btclassic-windows-screen@3x-2992252e3b2a89fcda155126208d4ff3.jpg";